var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { setComponentTemplate } from '@ember/component';
import { hbs } from 'ember-cli-htmlbars';
import { emit, select } from '@banking/ui/services/card-settings';
import { action } from '@ember/object';
import { Card } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { CardCustomization } from '@square/dashboard-protos/models/squareup/bizbank/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { CardSettingError, setActiveSettingAction, Setting as WorkflowSetting, userClickActivateCardAction, DepositAccountDataState, userClickViewReplacementCardAction } from '@banking/ui/workflows/card-settings';
import { CancellationType } from '@banking/ui/workflows/card-settings/cancel-card';
import { select as selectBillingAddressState, emit as emitBillingAddressAction } from '@banking/ui/services/card-management/billing-address';
import { getCardSettings } from '@banking/ui/utils/card-settings-utils';
import { getDocumentSettings } from '@banking/ui/utils/document-settings-utils';
import { canAccessStatements } from '@banking/ui/utils/country-permissions';
import { getHelpSettings } from '@banking/ui/utils/help-settings-utils';
import { InitializationReason, initializeAction as initializeBillingAddressAction, Loading } from '@banking/ui/workflows/card-settings/billing-address';
import { getCardStatusPill } from '@banking/ui/utils/card-status-pill-utils';
let ConnectedPage = (_dec = service('card-settings'), _dec2 = select(state => state.loading), _dec3 = select(state => state.card || Card.create({})), _dec4 = select(state => state.cardCustomization || CardCustomization.create()), _dec5 = select(state => state.card ? getCardStatusPill(state.card) : null), _dec6 = select(state => state.activeSetting === WorkflowSetting.AtmLimits), _dec7 = select(state => state.activeSetting === WorkflowSetting.NotificationsPreferences), _dec8 = select(state => state), _dec9 = select(state => state.error !== CardSettingError.None), _dec10 = select(state => state.depositAccountData === DepositAccountDataState.FETCHING), _dec11 = select(state => state.showCardDetails), _dec12 = selectBillingAddressState(state => state.billingAddress), _dec13 = selectBillingAddressState(state => state.loading === Loading.InBackground), _class = class ConnectedPage extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "applicationRouter", _descriptor, this);
    _initializerDefineProperty(this, "cardSettingsState", _descriptor2, this);
    _initializerDefineProperty(this, "features", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor5, this);
    _initializerDefineProperty(this, "userInfo", _descriptor6, this);
    _initializerDefineProperty(this, "loading", _descriptor7, this);
    _initializerDefineProperty(this, "card", _descriptor8, this);
    _initializerDefineProperty(this, "cardCustomization", _descriptor9, this);
    _initializerDefineProperty(this, "cardStatusPill", _descriptor10, this);
    _initializerDefineProperty(this, "isAtmLimitsOpen", _descriptor11, this);
    _initializerDefineProperty(this, "isNotificationPreferencesOpen", _descriptor12, this);
    _initializerDefineProperty(this, "state", _descriptor13, this);
    _initializerDefineProperty(this, "hasError", _descriptor14, this);
    _initializerDefineProperty(this, "loadingDocumentSettings", _descriptor15, this);
    _initializerDefineProperty(this, "showCardDetails", _descriptor16, this);
    _initializerDefineProperty(this, "billingAddress", _descriptor17, this);
    _initializerDefineProperty(this, "billingAddressLoading", _descriptor18, this);
  }
  get cardSettings() {
    return getCardSettings(this.cardSettingsState.emit.bind(this.cardSettingsState), this.intl.t.bind(this.intl), this.storedBalanceProductPositioning.productName)(this.state);
  }
  get helpSettings() {
    return getHelpSettings(this.cardSettingsState.emit.bind(this.cardSettingsState), this.intl.t.bind(this.intl), this.storedBalanceProductPositioning.productName, Country[this.userInfo.countryCode])(this.state);
  }
  get documentSettings() {
    return getDocumentSettings(this.intl.t.bind(this.intl), canAccessStatements(this.userInfo), this.card.id, this.args.unitToken, this.applicationRouter.transitionTo.bind(this.applicationRouter))(this.state);
  }
  onActivateCardClick() {
    return userClickActivateCardAction();
  }
  onAtmLimitsClose() {
    return setActiveSettingAction(WorkflowSetting.None);
  }
  onNotificationPreferencesClose() {
    return setActiveSettingAction(WorkflowSetting.None);
  }
  onViewReplacementCardClick() {
    return userClickViewReplacementCardAction();
  }
  onNeverReceivedCardClick() {
    this.cardSettingsState.openCancelCardModal(CancellationType.AccountHolderNeverReceivedCard);
  }
  onWrongAddressClick() {
    return initializeBillingAddressAction({
      expiringCardToken: this.card.id,
      unitToken: this.args.unitToken,
      reason: InitializationReason.CLICK_WRONG_REPLACEMENT_CARD_ADDRESS
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cardSettingsState", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "loading", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "card", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "cardCustomization", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "cardStatusPill", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isAtmLimitsOpen", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isNotificationPreferencesOpen", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "hasError", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "loadingDocumentSettings", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showCardDetails", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "billingAddress", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "billingAddressLoading", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onActivateCardClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onActivateCardClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAtmLimitsClose", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onAtmLimitsClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNotificationPreferencesClose", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onNotificationPreferencesClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onViewReplacementCardClick", [emit], Object.getOwnPropertyDescriptor(_class.prototype, "onViewReplacementCardClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNeverReceivedCardClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onNeverReceivedCardClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWrongAddressClick", [emitBillingAddressAction], Object.getOwnPropertyDescriptor(_class.prototype, "onWrongAddressClick"), _class.prototype), _class);
export { ConnectedPage as default };
setComponentTemplate(hbs`
    <Banking::Checking::CardSettings::Page
      @loading={{this.loading}}
      @billingAddress={{this.billingAddress}}
      @billingAddressLoading={{this.billingAddressLoading}}
      @card={{this.card}}
      @cardCustomization={{this.cardCustomization}}
      @cardSettings={{this.cardSettings}}
      @cardStatusPill={{this.cardStatusPill}}
      @documentSettings={{this.documentSettings}}
      @hasError={{this.hasError}}
      @helpSettings={{this.helpSettings}}
      @isAtmLimitsOpen={{this.isAtmLimitsOpen}}
      @isNotificationPreferencesOpen={{this.isNotificationPreferencesOpen}}
      @unitToken={{this.args.unitToken}}
      @onActivateCardClick={{this.onActivateCardClick}}
      @onGetPhysicalCardClick={{@onGetPhysicalCardClick}}
      @onAtmLimitsClose={{this.onAtmLimitsClose}}
      @onNeverReceivedCardClick={{this.onNeverReceivedCardClick}}
      @onNotificationPreferencesClose={{this.onNotificationPreferencesClose}}
      @onViewReplacementCardClick={{this.onViewReplacementCardClick}}
      @onWrongAddressClick={{this.onWrongAddressClick}}
      @goToOverview={{this.args.goToOverview}}
      @showCardDetails={{this.showCardDetails}}
      @loadingDocumentSettings={{this.loadingDocumentSettings}}
    />
  `, ConnectedPage);